import React, { useState } from 'react';
import { Box, Slider, Typography } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';

interface PrioritySliderProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

const gradientAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const StyledSlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.primary.main,
  height: 0,
  padding: '8px 0',
  '& .MuiSlider-thumb': {
    height: 12,
    width: 12,
    backgroundColor: '#5a5a5aff',
    '&:focus, &:hover, &.Mui-active': {
      boxShadow: 'inherit',
    },
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  },
  '& .MuiSlider-track': {
    height: 4,
    border: 'none',
    background: 'linear-gradient(90deg, #2088ff, #a455ff)',
    backgroundSize: '200% 200%',
    animation: `${gradientAnimation} 3s ease infinite`,
    borderRadius: 2,
  },
  '& .MuiSlider-rail': {
    height: 4,
    opacity: 0.2,
    backgroundColor: '#bfbfbf',
  },
  '& .MuiSlider-mark': {
    height: 4,
    width: 2,
    backgroundColor: 'rgba(255,255,255,0.3)',
  },
  '& .MuiSlider-markLabel': {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
  },
  '& .MuiSlider-valueLabel': {
    background: 'linear-gradient(135deg, #2088ff, #a455ff)',
    borderRadius: '6px',
    padding: '2px 6px',
    fontSize: '0.75rem',
    fontWeight: 'bold',
  },
}));

const marks = [
  { value: 0},
  { value: 1},
  { value: 2},
  { value: 3},
  { value: 4},
  { value: 5},
];

const PrioritySlider: React.FC<PrioritySliderProps> = ({ value, onChange, disabled = false }) => {
  const [localValue, setLocalValue] = useState<number>(value);

  // 親コンポーネントからのvalue変更を反映
  React.useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (_event: Event, newValue: number | number[]) => {
    const priority = newValue as number;
    setLocalValue(priority);
  };

  const handleChangeCommitted = (_event: React.SyntheticEvent | Event, newValue: number | number[]) => {
    const priority = newValue as number;
    onChange(priority);
  };

  const handleBoxClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Box 
      onClick={handleBoxClick}
      onMouseDown={handleBoxClick}
      sx={{ 
        width: '100%',
        px: 1,
        py: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      }}
    >
      {/* <Typography 
        variant="caption" 
        color="text.secondary"
        sx={{ 
          display: 'block',
          mb: 0,
          fontSize: '0.675rem'
        }}
      >
        優先度
      </Typography> */}
      <StyledSlider
        value={localValue}
        min={0}
        max={5}
        step={1}
        marks={marks}
        onChange={handleChange}
        onChangeCommitted={handleChangeCommitted}
        valueLabelDisplay="auto"
        disabled={disabled}
        sx={{ mt: 0 }}
      />
    </Box>
  );
};

export default PrioritySlider; 